export const theme = [
  {
    value: "Light Mode",
    style: "bg-white",
  },
  {
    value: "Dark Mode",
    style: "bg-slate-900",
  },
];
